import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';
import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const SchedulingHome = lazy(() =>
  import('./pages/SchedulingHome').then((module) => ({ default: module.SchedulingHome })),
);
const ScheduleDetailPage = lazy(() =>
  import('./pages/ScheduleDetailPage').then((module) => ({ default: module.ScheduleDetailPage })),
);
const ScheduleEditPage = lazy(() =>
  import('./pages/ScheduleEditPage').then((module) => ({ default: module.ScheduleEditPage })),
);
const AssignmentsPage = lazy(() =>
  import('./pages/AssignmentsPage').then((module) => ({ default: module.AssignmentsPage })),
);
const BulkAssignmentPage = lazy(() =>
  import('./pages/BulkAssignmentPage').then((module) => ({ default: module.BulkAssignmentPage })),
);
const BatchesPage = lazy(() =>
  import('./pages/BatchesPage').then((module) => ({ default: module.BatchesPage })),
);
const BatchDetailPage = lazy(() =>
  import('./pages/BatchDetailPage').then((module) => ({ default: module.BatchDetailPage })),
);
const AvailabilityPage = lazy(() =>
  import('./pages/AvailabilityPage').then((module) => ({ default: module.AvailabilityPage })),
);
const AvailabilityFormPage = lazy(() =>
  import('./pages/AvailabilityFormPage').then((module) => ({
    default: module.AvailabilityFormPage,
  })),
);
const AvailabilityDetailPage = lazy(() =>
  import('./pages/AvailabilityDetailPage').then((module) => ({
    default: module.AvailabilityDetailPage,
  })),
);
const CalendarPage = lazy(() =>
  import('./pages/CalendarPage').then((module) => ({ default: module.CalendarPage })),
);

export const schedulingRoutes: RouteObject[] = [
  {
    path: 'horarios',
    element: createElement(ProtectedRoute, { view: 'scheduling' }),
    children: [{ index: true, element: createElement(SchedulingHome) }],
  },
  {
    path: 'horarios/:id',
    element: createElement(ProtectedRoute, { view: 'workSchedules' }),
    children: [
      { index: true, element: createElement(ScheduleDetailPage) },
      { path: 'nueva-version', element: createElement(ScheduleEditPage, { mode: 'revise' }) },
      { path: 'editar', element: createElement(ScheduleEditPage, { mode: 'edit' }) },
    ],
  },
  {
    path: 'horarios/asignaciones',
    element: createElement(ProtectedRoute, { view: 'scheduleAssignments' }),
    children: [
      { index: true, element: createElement(AssignmentsPage) },
      { path: 'masiva', element: createElement(BulkAssignmentPage) },
      { path: 'lotes', element: createElement(BatchesPage) },
      { path: 'lotes/:id', element: createElement(BatchDetailPage) },
    ],
  },
  {
    path: 'horarios/disponibilidad',
    element: createElement(ProtectedRoute, { view: 'scheduleAvailability' }),
    children: [
      { index: true, element: createElement(AvailabilityPage) },
      { path: 'nueva', element: createElement(AvailabilityFormPage) },
      { path: ':id', element: createElement(AvailabilityDetailPage) },
      { path: ':id/editar', element: createElement(AvailabilityFormPage) },
    ],
  },
  {
    path: 'horarios/calendario',
    element: createElement(ProtectedRoute, { view: 'scheduleCalendar' }),
    children: [{ index: true, element: createElement(CalendarPage) }],
  },
];
